/**
 * Facebook Analytics service for tracking events
 */

/**
 * Track a page view
 * @param {string} url - The URL of the page being viewed
 */
export const trackPageView = (url) => {
	if (window.fbq) {
		window.fbq('track', 'PageView', { url })
	}
}

/**
 * Track a product view
 * @param {Object} product - The product being viewed
 * @param {string} product.id - The product ID
 * @param {string} product.title - The product title
 * @param {number} product.price - The product price
 */
export const trackViewContent = (product) => {
	if (window.fbq) {
		window.fbq('track', 'ViewContent', {
			content_ids: [product.id],
			content_name: product.title,
			content_type: 'product',
			value: parseFloat(product.price),
			currency: 'MXN'
		})
	}
}

/**
 * Track adding a product to cart
 * @param {Object} product - The product being added to cart
 * @param {string} product.id - The product ID
 * @param {string} product.title - The product title
 * @param {number} product.price - The product price
 * @param {number} [quantity=1] - The quantity being added
 */
export const trackAddToCart = (product, quantity = 1) => {
	if (window.fbq) {
		window.fbq('track', 'AddToCart', {
			content_ids: [product.id],
			content_name: product.title,
			content_type: 'product',
			value: parseFloat(product.price) * quantity,
			currency: 'MXN',
			quantity: quantity
		})
	}
}

/**
 * Track initiating checkout
 * @param {Object} checkout - The checkout data
 * @param {Array} checkout.contents - Array of items in cart
 * @param {string} checkout.content_type - Type of content being checked out
 * @param {number} checkout.value - Total value of checkout
 * @param {string} checkout.currency - Currency code
 */
export const trackInitiateCheckout = (checkout) => {
	if (window.fbq) {
		window.fbq('track', 'InitiateCheckout', {
			contents: checkout.contents,
			content_type: checkout.content_type,
			value: checkout.value,
			currency: checkout.currency
		})
	}
}

/**
 * Track a purchase
 * @param {Object} club - The club data
 * @param {number} club.precio - The price of the club
 * @param {string} club.title - The title of the club
 * @param {string} [club.id] - The ID of the club
 */
export const trackPurchase = (club) => {
	if (window.fbq) {
		window.fbq('track', 'Purchase', {
			value: club.precio,
			currency: 'MXN',
			content_name: club.title,
			content_type: 'subscription'
		})
	}
}

/**
 * Track a "quiero" button click
 * @param {Object} club - The club data
 */
export const trackQuieroButtonClick = (club) => {
	if (window.fbq) {
		window.fbq('trackCustom', 'ClickClubQuieroButton', {
			club: club
		})
	}
}
